/**
 * apiClient centralizado (arquitectura objetivo del refactor incremental).
 *
 * Instancia axios única con baseURL desde config + JWT auto-attach. Lo adoptan
 * las features NUEVAS; el código legacy sigue usando axios+baseAPI directo hasta
 * que se migre.
 */
import axios from 'axios';
import { baseAPI } from '../../config';

const apiClient = axios.create({ baseURL: baseAPI });

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;
